import { render, staticRenderFns } from "./CardLimitsReviewModal.vue?vue&type=template&id=503012a3"
import script from "./CardLimitsReviewModal.vue?vue&type=script&lang=js"
export * from "./CardLimitsReviewModal.vue?vue&type=script&lang=js"
import style0 from "./CardLimitsReviewModal.vue?vue&type=style&index=0&id=503012a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports